export const ReactMutationKeys = {
  // Companies
  CREATE_COMPANY: 'create-company',
  UPDATE_COMPANY: 'update-company',
  DELETE_COMPANY: 'delete-company',

  // Users
  CREATE_USER: 'create-user',
  UPDATE_USER: 'update-user',
  DELETE_USER: 'delete-user',
  RESET_PASSWORD: 'reset-password',
  ASSIGN_USER_TO_COMPANY: 'assign-user-to-company',

  // Machines
  CREATE_MACHINE: 'create-machine',
  UPDATE_MACHINE: 'update-machine',
  DELETE_MACHINE: 'delete-machine',

  // Products
  CREATE_PRODUCT: 'create-product',
  UPDATE_PRODUCT: 'update-product',
  DELETE_PRODUCT: 'delete-product',
} as const;
